const HOLIDAYS = [
  "New Year's Day",
  "Martin Luther King Jr. Day",
  "Presidents' Day",
  "Memorial Day",
  "Juneteenth",
  "Independence Day",
  "Labor Day",
  "Columbus Day / Indigenous Peoples' Day",
  "Veterans Day",
  "Thanksgiving Day",
  "Christmas Day",
];

const defaults = () => HOLIDAYS.map((name) => ({ name, selected: false, policy: "closed", start: "08:00", end: "17:00" }));

export function HolidaySchedule({ draft, setDraft }) {
  const holidays = Array.isArray(draft.coverage?.holidaySchedule) && draft.coverage.holidaySchedule.length === HOLIDAYS.length ? draft.coverage.holidaySchedule : defaults();
  const update = (index, patch) => {
    const next = holidays.map((holiday, holidayIndex) => holidayIndex === index ? { ...holiday, ...patch } : holiday);
    const selected = next.filter((holiday) => holiday.selected).map((holiday) => `${holiday.name}: ${holiday.policy === "closed" ? "Closed" : `${holiday.start || "?"}-${holiday.end || "?"}`}`).join("; ");
    setDraft((current) => ({ ...current, coverage: { ...current.coverage, holidaySchedule: next, closures: selected || "No government holidays selected" } }));
  };
  return <div className="holiday-schedule"><div className="holiday-intro"><b>Government holiday closures</b><span>Check the holidays your shop observes. Leave unchecked when you are open as usual.</span></div>{holidays.map((holiday, index) => <div className="holiday-row" key={holiday.name}><label><input type="checkbox" checked={!!holiday.selected} onChange={(event) => update(index, { selected: event.target.checked })}/><span>{holiday.name}</span></label>{holiday.selected&&<><select value={holiday.policy||"closed"} onChange={(event) => update(index, { policy: event.target.value })}><option value="closed">Closed</option><option value="hours">Open custom hours</option></select>{holiday.policy==="hours"&&<><input type="time" value={holiday.start||""} onChange={(event) => update(index, { start: event.target.value })}/><input type="time" value={holiday.end||""} onChange={(event) => update(index, { end: event.target.value })}/></>}</>}</div>)}</div>;
}
